import React from "react";
import AddReward from "./AddReward";
import Reward from "./Reward";
import { observer } from "mobx-react";
import { observable } from "mobx";
import axios from "axios";

var store = observable({
  adding: false,
  rewards: []
});

const getData = id => {
  axios.get(`/admin/opportunities/${id}/rewards`).then(response => {
    store.rewards = response.data.rewards;
  });
};

class RewardManagement extends React.Component {
  addReward() {
    store.adding = true;
  }

  finishAdd() {
    getData(this.props.opportunity.id);
    store.adding = false;
  }

  onRemove() {
    getData(this.props.opportunity.id);
  }

  componentDidMount() {
    getData(this.props.opportunity.id);
  }

  render() {
    const { statuses } = this.props;

    return (
      <div>
        <div className="field is-grouped">
          <p className="control is-expanded">
            <label className="label">Rewards</label>
          </p>
          {store.adding
            ? <AddReward
                statuses={statuses}
                opportunity={this.props.opportunity}
                onFinish={this.finishAdd.bind(this)}
              />
            : <p className="control">
                <a
                  className="button is-info"
                  onClick={this.addReward.bind(this)}
                >
                  + Reward
                </a>
              </p>}
        </div>
        {store.rewards.map(r => (
          <Reward {...r} key={r.id} onRemove={this.onRemove.bind(this)} />
        ))}
      </div>
    );
  }
}

export default observer(RewardManagement);
